var _path, _path2, _path3, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.1667 11.6667H15.8334C13.5322 11.6667 11.6667 13.5322 11.6667 15.8334V24.1667C11.6667 26.4679 13.5322 28.3334 15.8334 28.3334H24.1667C26.4679 28.3334 28.3334 26.4679 28.3334 24.1667V15.8334C28.3334 13.5322 26.4679 11.6667 24.1667 11.6667Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3333 19.475C23.4361 20.1685 23.3176 20.8769 22.9947 21.4992C22.6718 22.1215 22.1609 22.6262 21.5346 22.9414C20.9083 23.2566 20.1986 23.3663 19.5064 23.255C18.8142 23.1436 18.1747 22.8167 17.679 22.321C17.1832 21.8252 16.8564 21.1857 16.745 20.4935C16.6336 19.8013 16.7433 19.0916 17.0585 18.4653C17.3737 17.8391 17.8784 17.3281 18.5007 17.0052C19.1231 16.6823 19.8314 16.5638 20.5249 16.6667C21.2324 16.7716 21.8873 17.1012 22.393 17.6069C22.8987 18.1126 23.2283 18.7676 23.3333 19.475Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5833 15.4167H24.5933",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19,
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/Instagram.e2a377811722fc69579c5a70dfd2a6d6.svg";
export { ForwardRef as ReactComponent };